module.exports = __webpack_public_path__ + "static/illustration_01-5be03d2400fff8aa7d90388a4392d803.svg";